"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8884],{

/***/ 95059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ AddToWalletTextOptions; },
  "Z": function() { return /* binding */ AddToWallet_AddToWalletButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var src = __webpack_require__(52775);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/BinanceChain.tsx
var BinanceChain = __webpack_require__(67290);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/CoinbaseWallet.tsx
var CoinbaseWallet = __webpack_require__(5203);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Opera.tsx
var Opera = __webpack_require__(58600);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/TokenPocket.tsx
var TokenPocket = __webpack_require__(2529);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/TrustWallet.tsx
var TrustWallet = __webpack_require__(62149);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Metamask.tsx
var Metamask = __webpack_require__(75545);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(98553);
// EXTERNAL MODULE: ./src/components/Logo/Logo.tsx
var Logo = __webpack_require__(52175);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/wagmi.esm.js + 25 modules
var wagmi_esm = __webpack_require__(38109);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./src/utils/wallet.ts
// Set of helper functions to facilitate wallet setup



/**
 * Prompt the user to add a custom token to metamask
 * @param tokenAddress
 * @param tokenSymbol
 * @param tokenDecimals
 * @returns {boolean} true if the token has been added, false otherwise
 */ var registerToken = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(tokenAddress, tokenSymbol, tokenDecimals, tokenLogo) {
        var image, tokenAdded;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    image = tokenLogo ? Logo/* BAD_SRCS */.X[tokenLogo] ? undefined : tokenLogo : undefined;
                    return [
                        4,
                        window.ethereum.request({
                            method: "wallet_watchAsset",
                            params: {
                                type: "ERC20",
                                options: {
                                    address: tokenAddress,
                                    symbol: tokenSymbol,
                                    decimals: tokenDecimals,
                                    image: image
                                }
                            }
                        })
                    ];
                case 1:
                    tokenAdded = _state.sent();
                    return [
                        2,
                        tokenAdded
                    ];
            }
        });
    });
    return function registerToken(tokenAddress, tokenSymbol, tokenDecimals, tokenLogo) {
        return _ref.apply(this, arguments);
    };
}();
var canRegisterToken = function() {
    var ref, ref1, ref2, ref3, ref4;
    return  true && // @ts-ignore
    !(window === null || window === void 0 ? void 0 : (ref = window.ethereum) === null || ref === void 0 ? void 0 : ref.isSafePal) && ((window === null || window === void 0 ? void 0 : (ref1 = window.ethereum) === null || ref1 === void 0 ? void 0 : ref1.isMetaMask) || (window === null || window === void 0 ? void 0 : (ref2 = window.ethereum) === null || ref2 === void 0 ? void 0 : ref2.isTrust) || (window === null || window === void 0 ? void 0 : (ref3 = window.ethereum) === null || ref3 === void 0 ? void 0 : ref3.isCoinbaseWallet) || (window === null || window === void 0 ? void 0 : (ref4 = window.ethereum) === null || ref4 === void 0 ? void 0 : ref4.isTokenPocket));
};

;// CONCATENATED MODULE: ./src/components/AddToWallet/AddToWalletButton.tsx









var AddToWalletTextOptions;
(function(AddToWalletTextOptions) {
    AddToWalletTextOptions[AddToWalletTextOptions["NO_TEXT"] = 0] = "NO_TEXT";
    AddToWalletTextOptions[AddToWalletTextOptions["TEXT"] = 1] = "TEXT";
    AddToWalletTextOptions[AddToWalletTextOptions["TEXT_WITH_ASSET"] = 2] = "TEXT_WITH_ASSET";
})(AddToWalletTextOptions || (AddToWalletTextOptions = {}));
var Icons = {
    // TODO: Brave
    Binance: BinanceChain/* default */.Z,
    "Coinbase Wallet": CoinbaseWallet/* default */.Z,
    Opera: Opera/* default */.Z,
    TokenPocket: TokenPocket/* default */.Z,
    "Trust Wallet": TrustWallet/* default */.Z,
    MetaMask: Metamask/* default */.Z
};
var getWalletText = function(textOptions, tokenSymbol, t) {
    return textOptions !== AddToWalletTextOptions.NO_TEXT && (textOptions === AddToWalletTextOptions.TEXT ? t("Add to Wallet") : t("Add %asset% to Wallet", {
        asset: tokenSymbol
    }));
};
var getWalletIcon = function(marginTextBetweenLogo, name) {
    var ref, ref1, ref2, ref3;
    var iconProps = (0,_object_spread/* default */.Z)({
        width: "16px"
    }, marginTextBetweenLogo && {
        ml: marginTextBetweenLogo
    });
    if (name && Icons[name]) {
        var Icon = Icons[name];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, (0,_object_spread/* default */.Z)({}, iconProps));
    }
    if (window === null || window === void 0 ? void 0 : (ref = window.ethereum) === null || ref === void 0 ? void 0 : ref.isTrust) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustWallet/* default */.Z, (0,_object_spread/* default */.Z)({}, iconProps));
    }
    if (window === null || window === void 0 ? void 0 : (ref1 = window.ethereum) === null || ref1 === void 0 ? void 0 : ref1.isCoinbaseWallet) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CoinbaseWallet/* default */.Z, (0,_object_spread/* default */.Z)({}, iconProps));
    }
    if (window === null || window === void 0 ? void 0 : (ref2 = window.ethereum) === null || ref2 === void 0 ? void 0 : ref2.isTokenPocket) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenPocket/* default */.Z, (0,_object_spread/* default */.Z)({}, iconProps));
    }
    if (window === null || window === void 0 ? void 0 : (ref3 = window.ethereum) === null || ref3 === void 0 ? void 0 : ref3.isMetaMask) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Metamask/* default */.Z, (0,_object_spread/* default */.Z)({}, iconProps));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Metamask/* default */.Z, (0,_object_spread/* default */.Z)({}, iconProps));
};
var AddToWalletButton = function(_param) {
    var tokenAddress = _param.tokenAddress, tokenSymbol = _param.tokenSymbol, tokenDecimals = _param.tokenDecimals, tokenLogo = _param.tokenLogo, _textOptions = _param.textOptions, textOptions = _textOptions === void 0 ? AddToWalletTextOptions.NO_TEXT : _textOptions, _marginTextBetweenLogo = _param.marginTextBetweenLogo, marginTextBetweenLogo = _marginTextBetweenLogo === void 0 ? "0px" : _marginTextBetweenLogo, props = (0,_object_without_properties/* default */.Z)(_param, [
        "tokenAddress",
        "tokenSymbol",
        "tokenDecimals",
        "tokenLogo",
        "textOptions",
        "marginTextBetweenLogo"
    ]);
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,wagmi_esm/* useAccount */.mA)(), connector = ref.connector, isConnected = ref.isConnected;
    var isCanRegisterToken = canRegisterToken();
    if (connector && connector.name === "Binance") return null;
    if (!(connector && connector.watchAsset && isConnected)) return null;
    if (!isCanRegisterToken) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        onClick: function() {
            var ref;
            var image = tokenLogo ? Logo/* BAD_SRCS */.X[tokenLogo] ? undefined : tokenLogo : undefined;
            (ref = connector.watchAsset) === null || ref === void 0 ? void 0 : ref.call(connector, {
                address: tokenAddress,
                symbol: tokenSymbol,
                image: image,
                // @ts-ignore
                decimals: tokenDecimals
            });
        },
        children: [
            getWalletText(textOptions, tokenSymbol, t),
            getWalletIcon(marginTextBetweenLogo, connector === null || connector === void 0 ? void 0 : connector.name)
        ]
    }));
};
/* harmony default export */ var AddToWallet_AddToWalletButton = (AddToWalletButton);


/***/ }),

/***/ 74054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52775);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97119);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  width: 0;\n  position: relative;\n  font-weight: 500;\n  outline: none;\n  border: none;\n  flex: 1 1 auto;\n  background-color: transparent;\n  font-size: 16px;\n  text-align: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0px;\n  -webkit-appearance: textfield;\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  [type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n  }\n\n  ::placeholder {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledInput = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-8de12016-0"
})(_templateObject(), function(param) {
    var error = param.error, theme = param.theme;
    return error ? theme.colors.failure : theme.colors.text;
}, function(param) {
    var align = param.align;
    return align !== null && align !== void 0 ? align : "right";
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var inputRegex = RegExp("^\\d*(?:\\\\[.])?\\d*$") // match escaped "." characters via in a non-capturing group
;
var Input = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function InnerInput(_param) {
    var value = _param.value, onUserInput = _param.onUserInput, placeholder = _param.placeholder, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "value",
        "onUserInput",
        "placeholder"
    ]);
    var enforcer = function(nextUserInput) {
        if (nextUserInput === "" || inputRegex.test((0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .escapeRegExp */ .hr)(nextUserInput))) {
            onUserInput(nextUserInput);
        }
    };
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledInput, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, rest), {
        value: value,
        onChange: function(event) {
            // replace commas with periods, because we exclusively uses period as the decimal separator
            enforcer(event.target.value.replace(/,/g, "."));
        },
        // universal input options
        inputMode: "decimal",
        title: t("Token Amount"),
        autoComplete: "off",
        autoCorrect: "off",
        // text-specific options
        type: "text",
        pattern: "^[0-9]*[.,]?[0-9]*$",
        placeholder: placeholder || "0.0",
        minLength: 1,
        maxLength: 79,
        spellCheck: "false"
    }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Input)));


/***/ }),

/***/ 38227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CurrencyInputPanel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(98553);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(21812);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(44147);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(62077);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(57049);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(19521);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97119);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52775);
/* harmony import */ var _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60890);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97477);
/* harmony import */ var hooks_useBUSDPrice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2629);
/* harmony import */ var utils_formatBalance__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59123);
/* harmony import */ var _state_wallet_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5460);
/* harmony import */ var _SearchModal_CurrencySearchModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91548);
/* harmony import */ var _Logo__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19259);
/* harmony import */ var _NumericalInput__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(74054);
/* harmony import */ var _CopyButton__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17235);
/* harmony import */ var _AddToWallet_AddToWalletButton__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(95059);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 8px;\n      background: ",
        ";\n      border: 1px solid ",
        ";\n      border-radius: ",
        " 8px 0px 0px;\n      height: auto;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 0.5rem;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  color: ",
        ";\n  font-size: 0.75rem;\n  line-height: 1rem;\n  padding: 0.75rem 1rem 0 1rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-flow: column nowrap;\n  position: relative;\n  background-color: ",
        ";\n  z-index: 1;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border-radius: 0px 16px 16px 16px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 16px;\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  inset: 0;\n  opacity: 0.6;\n  background-color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}















var InputRow = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed726ef6-0"
})(_templateObject(), function(param) {
    var selected = param.selected;
    return selected ? "0.75rem 0.5rem 0.75rem 1rem" : "0.75rem 0.75rem 0.75rem 1rem";
});
var CurrencySelectButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z).attrs({
    variant: "text",
    scale: "sm"
}).withConfig({
    componentId: "sc-ed726ef6-1"
})(_templateObject2(), function(param) {
    var zapStyle = param.zapStyle, theme = param.theme;
    return zapStyle && (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* .css */ .iv)(_templateObject1(), theme.colors.background, theme.colors.cardBorder, zapStyle === "zap" ? "0px" : "8px");
});
var LabelRow = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed726ef6-2"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var InputPanel = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed726ef6-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var Container = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed726ef6-4"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme, error = param.error;
    return theme.shadows[error ? "warning" : "inset"];
}, function(param) {
    var zapStyle = param.zapStyle;
    return !!zapStyle && (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* .css */ .iv)(_templateObject5());
});
var Overlay = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed726ef6-5"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
function CurrencyInputPanel(param) {
    var value = param.value, onUserInput = param.onUserInput, onInputBlur = param.onInputBlur, onMax = param.onMax, showMaxButton = param.showMaxButton, label = param.label, onCurrencySelect = param.onCurrencySelect, currency = param.currency, _disableCurrencySelect = param.disableCurrencySelect, disableCurrencySelect = _disableCurrencySelect === void 0 ? false : _disableCurrencySelect, _hideBalance = param.hideBalance, hideBalance = _hideBalance === void 0 ? false : _hideBalance, zapStyle = param.zapStyle, beforeButton = param.beforeButton, _pair = param.pair, pair = _pair === void 0 ? null : _pair, otherCurrency = param.otherCurrency, id = param.id, showCommonBases = param.showCommonBases, commonBasesType = param.commonBasesType, disabled = param.disabled, error = param.error, showBUSD = param.showBUSD;
    var account = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().account;
    var selectedCurrencyBalance = (0,_state_wallet_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useCurrencyBalance */ ._h)(account !== null && account !== void 0 ? account : undefined, currency !== null && currency !== void 0 ? currency : undefined);
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var token = pair ? pair.liquidityToken : (currency === null || currency === void 0 ? void 0 : currency.isToken) ? currency : null;
    var tokenAddress = token ? (0,utils__WEBPACK_IMPORTED_MODULE_2__/* .isAddress */ .UJ)(token.address) : null;
    var amountInDollar = (0,hooks_useBUSDPrice__WEBPACK_IMPORTED_MODULE_6__/* .useBUSDCurrencyAmount */ .vB)(showBUSD ? currency : undefined, Number.isFinite(+value) ? +value : undefined);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SearchModal_CurrencySearchModal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        onCurrencySelect: onCurrencySelect,
        selectedCurrency: currency,
        otherSelectedCurrency: otherCurrency,
        showCommonBases: showCommonBases,
        commonBasesType: commonBasesType
    })), 1), onPresentCurrencyModal = ref[0];
    var ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
        position: "relative",
        id: id,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        children: [
                            beforeButton,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CurrencySelectButton, {
                                zapStyle: zapStyle,
                                className: "open-currency-select-button",
                                selected: !!currency,
                                onClick: function() {
                                    if (!disableCurrencySelect) {
                                        onPresentCurrencyModal();
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    children: [
                                        pair ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Logo__WEBPACK_IMPORTED_MODULE_10__/* .DoubleCurrencyLogo */ .ge, {
                                            currency0: pair.token0,
                                            currency1: pair.token1,
                                            size: 16,
                                            margin: true
                                        }) : currency ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Logo__WEBPACK_IMPORTED_MODULE_10__/* .CurrencyLogo */ .Xw, {
                                            currency: currency,
                                            size: "24px",
                                            style: {
                                                marginRight: "8px"
                                            }
                                        }) : null,
                                        pair ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                            id: "pair",
                                            bold: true,
                                            children: [
                                                pair === null || pair === void 0 ? void 0 : pair.token0.symbol,
                                                ":",
                                                pair === null || pair === void 0 ? void 0 : pair.token1.symbol
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                            id: "pair",
                                            bold: true,
                                            children: (currency && currency.symbol && currency.symbol.length > 20 ? "".concat(currency.symbol.slice(0, 4), "...").concat(currency.symbol.slice(currency.symbol.length - 5, currency.symbol.length)) : currency === null || currency === void 0 ? void 0 : currency.symbol) || t("Select a currency")
                                        }),
                                        !disableCurrencySelect && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {})
                                    ]
                                })
                            }),
                            token && tokenAddress ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                style: {
                                    gap: "4px"
                                },
                                ml: "4px",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_CopyButton__WEBPACK_IMPORTED_MODULE_12__/* .CopyButton */ .q, {
                                        width: "16px",
                                        buttonColor: "textSubtle",
                                        text: tokenAddress,
                                        tooltipMessage: t("Token address copied"),
                                        tooltipTop: -20,
                                        tooltipRight: 40,
                                        tooltipFontSize: 12
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_AddToWallet_AddToWalletButton__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        variant: "text",
                                        p: "0",
                                        height: "auto",
                                        width: "fit-content",
                                        tokenAddress: tokenAddress,
                                        tokenSymbol: token.symbol,
                                        tokenDecimals: token.decimals,
                                        tokenLogo: (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(token, _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_4__/* .WrappedTokenInfo */ .DT) ? token.logoURI : undefined
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    account && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        onClick: !disabled && onMax,
                        color: "textSubtle",
                        fontSize: "14px",
                        style: {
                            display: "inline",
                            cursor: "pointer"
                        },
                        children: !hideBalance && !!currency ? t("Balance: %balance%", {
                            balance: (ref1 = selectedCurrencyBalance === null || selectedCurrencyBalance === void 0 ? void 0 : selectedCurrencyBalance.toSignificant(6)) !== null && ref1 !== void 0 ? ref1 : t("Loading")
                        }) : " -"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(InputPanel, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, {
                        as: "label",
                        zapStyle: zapStyle,
                        error: error,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LabelRow, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_NumericalInput__WEBPACK_IMPORTED_MODULE_11__/* .Input */ .I, {
                                    error: error,
                                    disabled: disabled,
                                    className: "token-amount-input",
                                    value: value,
                                    onBlur: onInputBlur,
                                    onUserInput: function(val) {
                                        onUserInput(val);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(InputRow, {
                                selected: disableCurrencySelect,
                                children: [
                                    !!currency && showBUSD && Number.isFinite(amountInDollar) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                        fontSize: "12px",
                                        color: "textSubtle",
                                        mr: "12px",
                                        children: [
                                            "~",
                                            (0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_7__/* .formatNumber */ .uf)(amountInDollar),
                                            " USD"
                                        ]
                                    }),
                                    account && currency && !disabled && showMaxButton && label !== "To" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        onClick: onMax,
                                        scale: "xs",
                                        variant: "secondary",
                                        style: {
                                            textTransform: "uppercase"
                                        },
                                        children: t("Max")
                                    })
                                ]
                            })
                        ]
                    }),
                    disabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Overlay, {})
                ]
            })
        ]
    });
}


/***/ }),

/***/ 38695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ht": function() { return /* binding */ TransactionErrorContent; },
/* harmony export */   "pM": function() { return /* binding */ ConfirmationModalContent; },
/* harmony export */   "rD": function() { return /* binding */ TransactionSubmittedContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52775);
/* harmony import */ var _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60890);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2164);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(62077);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(40696);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(98768);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(98553);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(44147);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(5389);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(85937);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97477);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19521);
/* harmony import */ var utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73938);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97119);
/* harmony import */ var _AddToWallet_AddToWalletButton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95059);
/* harmony import */ var _Layout_Column__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(941);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f333b5f0-0"
})(_templateObject());
var Section = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_Layout_Column__WEBPACK_IMPORTED_MODULE_9__/* .AutoColumn */ .Tz).withConfig({
    componentId: "sc-f333b5f0-1"
})(_templateObject1());
var ConfirmedIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_Layout_Column__WEBPACK_IMPORTED_MODULE_9__/* .ColumnCenter */ .lg).withConfig({
    componentId: "sc-f333b5f0-2"
})(_templateObject2());
function ConfirmationPendingContent(param) {
    var pendingText = param.pendingText;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConfirmedIcon, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Column__WEBPACK_IMPORTED_MODULE_9__/* .AutoColumn */ .Tz, {
                gap: "12px",
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        fontSize: "20px",
                        children: t("Waiting For Confirmation")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Layout_Column__WEBPACK_IMPORTED_MODULE_9__/* .AutoColumn */ .Tz, {
                        gap: "12px",
                        justify: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            bold: true,
                            small: true,
                            textAlign: "center",
                            children: pendingText
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        small: true,
                        color: "textSubtle",
                        textAlign: "center",
                        children: t("Confirm this transaction in your wallet")
                    })
                ]
            })
        ]
    });
}
function TransactionSubmittedContent(param) {
    var onDismiss = param.onDismiss, chainId = param.chainId, hash = param.hash, currencyToAdd = param.currencyToAdd;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var token = (0,utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_6__/* .wrappedCurrency */ .pu)(currencyToAdd, chainId);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Section, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConfirmedIcon, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        strokeWidth: 0.5,
                        width: "90px",
                        color: "primary"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Column__WEBPACK_IMPORTED_MODULE_9__/* .AutoColumn */ .Tz, {
                    gap: "12px",
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            fontSize: "20px",
                            children: t("Transaction Submitted")
                        }),
                        chainId && hash && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            external: true,
                            small: true,
                            href: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .getBlockExploreLink */ .C)(hash, "transaction", chainId),
                            children: t("View on %site%", {
                                site: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .getBlockExploreName */ .X0)(chainId)
                            })
                        }),
                        currencyToAdd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_AddToWallet_AddToWalletButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: "tertiary",
                            mt: "12px",
                            width: "fit-content",
                            marginTextBetweenLogo: "6px",
                            textOptions: _AddToWallet_AddToWalletButton__WEBPACK_IMPORTED_MODULE_8__/* .AddToWalletTextOptions.TEXT_WITH_ASSET */ .L.TEXT_WITH_ASSET,
                            tokenAddress: token.address,
                            tokenSymbol: currencyToAdd.symbol,
                            tokenDecimals: token.decimals,
                            tokenLogo: (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(token, _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_3__/* .WrappedTokenInfo */ .DT) ? token.logoURI : undefined
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            onClick: onDismiss,
                            mt: "20px",
                            children: t("Close")
                        })
                    ]
                })
            ]
        })
    });
}
function ConfirmationModalContent(param) {
    var bottomContent = param.bottomContent, topContent = param.topContent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                children: topContent()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                children: bottomContent()
            })
        ]
    });
}
function TransactionErrorContent(param) {
    var message = param.message, onDismiss = param.onDismiss;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Column__WEBPACK_IMPORTED_MODULE_9__/* .AutoColumn */ .Tz, {
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        color: "failure",
                        width: "64px"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        color: "failure",
                        style: {
                            textAlign: "center",
                            width: "85%",
                            wordBreak: "break-word"
                        },
                        children: message
                    })
                ]
            }),
            onDismiss ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                justifyContent: "center",
                pt: "24px",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    onClick: onDismiss,
                    children: t("Dismiss")
                })
            }) : null
        ]
    });
}
var TransactionConfirmationModal = function(_param) {
    var title = _param.title, onDismiss = _param.onDismiss, customOnDismiss = _param.customOnDismiss, attemptingTxn = _param.attemptingTxn, hash = _param.hash, pendingText = _param.pendingText, content = _param.content, currencyToAdd = _param.currencyToAdd, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, [
        "title",
        "onDismiss",
        "customOnDismiss",
        "attemptingTxn",
        "hash",
        "pendingText",
        "content",
        "currencyToAdd"
    ]);
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().chainId;
    var handleDismiss = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function() {
        if (customOnDismiss) {
            customOnDismiss();
        }
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, [
        customOnDismiss,
        onDismiss
    ]);
    if (!chainId) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({
        title: title,
        headerBackground: "gradientCardHeader"
    }, props), {
        onDismiss: handleDismiss,
        children: attemptingTxn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConfirmationPendingContent, {
            pendingText: pendingText
        }) : hash ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TransactionSubmittedContent, {
            chainId: chainId,
            hash: hash,
            onDismiss: handleDismiss,
            currencyToAdd: currencyToAdd
        }) : content()
    }));
};
/* harmony default export */ __webpack_exports__["ZP"] = (TransactionConfirmationModal);


/***/ }),

/***/ 58390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49081);
/* harmony import */ var _gelatonetwork_limit_orders_lib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55855);
/* harmony import */ var _gelatonetwork_limit_orders_lib__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_gelatonetwork_limit_orders_lib__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97477);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56974);
/* harmony import */ var hooks_useProviderOrSigner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99648);






var useGelatoLimitOrdersLib = function() {
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().chainId;
    var providerOrSigner = (0,hooks_useProviderOrSigner__WEBPACK_IMPORTED_MODULE_5__/* .useProviderOrSigner */ .J)();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!chainId || !providerOrSigner) {
            console.error("Could not instantiate GelatoLimitOrders: missing chainId or library");
            return undefined;
        }
        if (chainId !== _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ChainId.BSC */ .a_.BSC) return undefined;
        try {
            return new _gelatonetwork_limit_orders_lib__WEBPACK_IMPORTED_MODULE_2__.GelatoLimitOrders(chainId, providerOrSigner, config_constants_exchange__WEBPACK_IMPORTED_MODULE_4__/* .GELATO_HANDLER */ .uX, false);
        } catch (error) {
            console.error("Could not instantiate GelatoLimitOrders: ".concat(error.message));
            return undefined;
        }
    }, [
        chainId,
        providerOrSigner
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useGelatoLimitOrdersLib);


/***/ }),

/***/ 94544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UK": function() { return /* binding */ ApprovalState; },
  "qL": function() { return /* binding */ useApproveCallback; },
  "tz": function() { return /* binding */ useApproveCallbackFromInputCurrencyAmount; },
  "re": function() { return /* binding */ useApproveCallbackFromTrade; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(21046);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var src = __webpack_require__(52775);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/ToastsContext/useToast.ts
var useToast = __webpack_require__(19237);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var wagmi_src = __webpack_require__(29315);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(56974);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/sentry.ts
var sentry = __webpack_require__(70486);
// EXTERNAL MODULE: ./src/state/swap/actions.ts
var actions = __webpack_require__(85588);
// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var hooks = __webpack_require__(56906);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./src/utils/exchange.ts + 1 modules
var utils_exchange = __webpack_require__(17937);
// EXTERNAL MODULE: ./src/hooks/limitOrders/useGelatoLimitOrdersLib.ts
var useGelatoLimitOrdersLib = __webpack_require__(58390);
// EXTERNAL MODULE: ./src/hooks/useCallWithGasPrice.ts
var useCallWithGasPrice = __webpack_require__(85900);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(36963);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 15 modules
var swap_sdk_src = __webpack_require__(49081);
// EXTERNAL MODULE: ./src/state/multicall/hooks.ts
var multicall_hooks = __webpack_require__(410);
;// CONCATENATED MODULE: ./src/hooks/useTokenAllowance.ts




function useTokenAllowance(token, owner, spender) {
    var contract = (0,useContract/* useTokenContract */.Ib)(token === null || token === void 0 ? void 0 : token.address, false);
    var inputs = (0,react.useMemo)(function() {
        return [
            owner,
            spender
        ];
    }, [
        owner,
        spender
    ]);
    var allowance = (0,multicall_hooks/* useSingleCallResult */.Wk)(contract, "allowance", inputs).result;
    return (0,react.useMemo)(function() {
        return token && allowance ? swap_sdk_src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(token, allowance.toString()) : undefined;
    }, [
        token,
        allowance
    ]);
}
/* harmony default export */ var hooks_useTokenAllowance = (useTokenAllowance);

;// CONCATENATED MODULE: ./src/hooks/useApproveCallback.ts

















var ApprovalState;
(function(ApprovalState) {
    ApprovalState[ApprovalState["UNKNOWN"] = 0] = "UNKNOWN";
    ApprovalState[ApprovalState["NOT_APPROVED"] = 1] = "NOT_APPROVED";
    ApprovalState[ApprovalState["PENDING"] = 2] = "PENDING";
    ApprovalState[ApprovalState["APPROVED"] = 3] = "APPROVED";
})(ApprovalState || (ApprovalState = {}));
// returns a variable indicating the state of the approval and a function which approves if necessary or early returns
function useApproveCallback(amountToApprove, spender) {
    var ref;
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var t = (0,src/* useTranslation */.$G)().t;
    var toastError = (0,useToast/* useToast */.p)().toastError;
    var token = (amountToApprove === null || amountToApprove === void 0 ? void 0 : (ref = amountToApprove.currency) === null || ref === void 0 ? void 0 : ref.isToken) ? amountToApprove.currency : undefined;
    var currentAllowance = hooks_useTokenAllowance(token, account !== null && account !== void 0 ? account : undefined, spender);
    var pendingApproval = (0,hooks/* useHasPendingApproval */.wB)(token === null || token === void 0 ? void 0 : token.address, spender);
    // check the current approval status
    var approvalState = (0,react.useMemo)(function() {
        var ref;
        if (!amountToApprove || !spender) return ApprovalState.UNKNOWN;
        if ((ref = amountToApprove.currency) === null || ref === void 0 ? void 0 : ref.isNative) return ApprovalState.APPROVED;
        // we might not have enough data to know whether or not we need to approve
        if (!currentAllowance) return ApprovalState.UNKNOWN;
        // amountToApprove will be defined if currentAllowance is
        return currentAllowance.lessThan(amountToApprove) ? pendingApproval ? ApprovalState.PENDING : ApprovalState.NOT_APPROVED : ApprovalState.APPROVED;
    }, [
        amountToApprove,
        currentAllowance,
        pendingApproval,
        spender
    ]);
    var tokenContract = (0,useContract/* useTokenContract */.Ib)(token === null || token === void 0 ? void 0 : token.address);
    var addTransaction = (0,hooks/* useTransactionAdder */.h7)();
    var approve = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var useExact, estimatedGas;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (approvalState !== ApprovalState.NOT_APPROVED) {
                        toastError(t("Error"), t("Approve was called unnecessarily"));
                        console.error("approve was called unnecessarily");
                        return [
                            2
                        ];
                    }
                    if (!token) {
                        toastError(t("Error"), t("No token"));
                        console.error("no token");
                        return [
                            2
                        ];
                    }
                    if (!tokenContract) {
                        toastError(t("Error"), t("Cannot find contract of the token %tokenAddress%", {
                            tokenAddress: token === null || token === void 0 ? void 0 : token.address
                        }));
                        console.error("tokenContract is null");
                        return [
                            2
                        ];
                    }
                    if (!amountToApprove) {
                        toastError(t("Error"), t("Missing amount to approve"));
                        console.error("missing amount to approve");
                        return [
                            2
                        ];
                    }
                    if (!spender) {
                        toastError(t("Error"), t("No spender"));
                        console.error("no spender");
                        return [
                            2
                        ];
                    }
                    useExact = false;
                    return [
                        4,
                        tokenContract.estimateGas.approve(spender, bignumbers/* MaxUint256 */.Bz).catch(function() {
                            // general fallback for tokens who restrict approval amounts
                            useExact = true;
                            return tokenContract.estimateGas.approve(spender, amountToApprove.quotient.toString());
                        })
                    ];
                case 1:
                    estimatedGas = _state.sent();
                    // eslint-disable-next-line consistent-return
                    return [
                        2,
                        callWithGasPrice(tokenContract, "approve", [
                            spender,
                            useExact ? amountToApprove.quotient.toString() : bignumbers/* MaxUint256 */.Bz
                        ], {
                            gasLimit: (0,utils/* calculateGasMargin */.yC)(estimatedGas)
                        }).then(function(response) {
                            addTransaction(response, {
                                summary: "Approve ".concat(amountToApprove.currency.symbol),
                                translatableSummary: {
                                    text: "Approve %symbol%",
                                    data: {
                                        symbol: amountToApprove.currency.symbol
                                    }
                                },
                                approval: {
                                    tokenAddress: token.address,
                                    spender: spender
                                },
                                type: "approve"
                            });
                        }).catch(function(error) {
                            (0,sentry/* logError */.H)(error);
                            console.error("Failed to approve token", error);
                            if ((error === null || error === void 0 ? void 0 : error.code) !== 4001) {
                                toastError(t("Error"), error.message);
                            }
                            throw error;
                        })
                    ];
            }
        });
    }), [
        approvalState,
        token,
        tokenContract,
        amountToApprove,
        spender,
        addTransaction,
        callWithGasPrice,
        t,
        toastError
    ]);
    return [
        approvalState,
        approve
    ];
}
// wraps useApproveCallback in the context of a swap
function useApproveCallbackFromTrade(trade) {
    var allowedSlippage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, chainId = arguments.length > 2 ? arguments[2] : void 0;
    var amountToApprove = (0,react.useMemo)(function() {
        return trade ? (0,utils_exchange/* computeSlippageAdjustedAmounts */.b5)(trade, allowedSlippage)[actions/* Field.INPUT */.gN.INPUT] : undefined;
    }, [
        trade,
        allowedSlippage
    ]);
    return useApproveCallback(amountToApprove, exchange/* ROUTER_ADDRESS */.bR[chainId]);
}
// Wraps useApproveCallback in the context of a Gelato Limit Orders
function useApproveCallbackFromInputCurrencyAmount(currencyAmountIn) {
    var gelatoLibrary = (0,useGelatoLimitOrdersLib/* default */.Z)();
    var _address;
    return useApproveCallback(currencyAmountIn, (_address = gelatoLibrary === null || gelatoLibrary === void 0 ? void 0 : gelatoLibrary.erc20OrderRouter.address) !== null && _address !== void 0 ? _address : undefined);
}


/***/ }),

/***/ 85900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useCallWithGasPrice; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var state_user_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(921);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64487);








function useCallWithGasPrice() {
    var gasPrice = (0,state_user_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useGasPrice */ .Fh)();
    /**
   * Perform a contract call with a gas price returned from useGasPrice
   * @param contract Used to perform the call
   * @param methodName The name of the method called
   * @param methodArgs An array of arguments to pass to the method
   * @param overrides An overrides object to pass to the method. gasPrice passed in here will take priority over the price returned by useGasPrice
   * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
   */ var callWithGasPrice = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(contract, methodName) {
            var methodArgs, overrides, contractMethod, hasManualGasPriceOverride, tx, ref;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        methodArgs = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : [], overrides = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : null;
                        (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .addBreadcrumb */ .n_)({
                            type: "Transaction",
                            message: "Call with gas price: ".concat(gasPrice),
                            data: {
                                contractAddress: contract.address,
                                methodName: methodName,
                                methodArgs: methodArgs,
                                overrides: overrides
                            }
                        });
                        contractMethod = lodash_get__WEBPACK_IMPORTED_MODULE_2___default()(contract, methodName);
                        hasManualGasPriceOverride = overrides === null || overrides === void 0 ? void 0 : overrides.gasPrice;
                        return [
                            4,
                            contractMethod.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(methodArgs).concat([
                                hasManualGasPriceOverride ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, overrides) : (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, overrides)
                            ]))
                        ];
                    case 1:
                        tx = _state.sent();
                        if (tx) {
                            ;
                            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .addBreadcrumb */ .n_)({
                                type: "Transaction",
                                message: "Transaction sent: ".concat(tx.hash),
                                data: {
                                    hash: tx.hash,
                                    from: tx.from,
                                    gasLimit: (ref = tx.gasLimit) === null || ref === void 0 ? void 0 : ref.toString(),
                                    nonce: tx.nonce
                                }
                            });
                        }
                        return [
                            2,
                            tx
                        ];
                }
            });
        });
        return function(contract, methodName) {
            return _ref.apply(this, arguments);
        };
    }(), [
        gasPrice
    ]);
    return {
        callWithGasPrice: callWithGasPrice
    };
}


/***/ }),

/***/ 70486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ logError; },
/* harmony export */   "Z": function() { return /* binding */ isUserRejected; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64487);


var assignError = function(maybeError) {
    if (typeof maybeError === "string") {
        return new Error(maybeError);
    }
    if (typeof maybeError === "object") {
        var ref;
        var error = new Error((ref = maybeError === null || maybeError === void 0 ? void 0 : maybeError.message) !== null && ref !== void 0 ? ref : String(maybeError));
        if (maybeError === null || maybeError === void 0 ? void 0 : maybeError.stack) {
            error.stack = maybeError.stack;
        }
        if (maybeError === null || maybeError === void 0 ? void 0 : maybeError.code) {
            error.name = maybeError.code;
        }
        return error;
    }
    return maybeError;
};
var isUserRejected = function(err) {
    // provider user rejected error code
    return typeof err === "object" && "code" in err && err.code === 4001;
};
var ENABLED_LOG = false;
var logError = function(error) {
    if (ENABLED_LOG) {
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(error, Error)) {
            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb)(error);
        } else {
            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb)(assignError(error), error);
        }
    }
    console.error(error);
};


/***/ })

}]);